import { createAsyncThunk } from "@reduxjs/toolkit";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";

export const getAllNotifications = createAsyncThunk(
  "notifications/getAllNotifications",
  async (body: any) => {
    try {
      // pageNumber = 0;
      const res = await ax.get<IApi>(
        `/get_user_notitifications/${body.userId}?pageNumber=${body.pageNumber}`
      );
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const markAsRead = createAsyncThunk("notifications/markAsRead", async (data: any) => {
  try {
    const res = await ax.put<IApi>("/update_user_notitification", data);
    if (res.data.isSuccess === true && res.data.value) return res.data.value;
    else throw new Error(res.data.error || res.statusText);
  } catch (error) {
    throw error;
  }
});

export const markAllAsRead = createAsyncThunk("notifications/markAllAsRead", async (data: any) => {
  try {
    const res = await ax.put<IApi>("/read_all_user_notitifications", data);
    if (res.data.isSuccess === true && res.data.value) return res.data.value;
    else throw new Error(res.data.error || res.statusText);
  } catch (error) {
    throw error;
  }
});
